// Single source of truth for Qude brand colors and styles.
// All screens should import from here — never hardcode colors inline.

export const PLAY_BUTTON_GRADIENT = 'linear-gradient(135deg, #7c3aed, #4A9EFF)';
export const ACCENT_GRADIENT      = 'linear-gradient(135deg, #7c3aed, #4A9EFF)';

export const CARD_BG        = '#0A0A0A';
export const CARD_BG_ALT    = '#111';
export const APP_BG         = '#050505';

export const BORDER_SUBTLE  = 'rgba(255,255,255,0.05)';
export const BORDER_DEFAULT = 'rgba(255,255,255,0.08)';

export const TEXT_PRIMARY   = '#ffffff';
export const TEXT_SECONDARY = 'rgba(255,255,255,0.5)';
export const TEXT_MUTED     = 'rgba(255,255,255,0.3)';

export const ACCENT_COLOR   = '#7c3aed';   // violet-600
export const ACCENT_CYAN    = '#4A9EFF';   // cyan-500
